import React, { useCallback } from 'react'
import styles from './OfferRegistration.module.css'
import ProgressBanner from '../../../components/Banner/ProgressBanner'
import { StepContainer } from '../../../components/Steps/StepContainer'
import { useStepHandler } from '../../../hooks/useStepHandler'
import { submitOfferApplyRegistration } from '../../api/offerApplyApi'
import { FormValues } from '../../../components/Store/reducers/formReducer/types'

type Props = {
    webhookUrl: string
    offerId: string
    // 単独ページ（DEV-3157: ログアウト時「新規登録して応募する」の遷移先）用。
    // 見出しはサーバ（@offer_apply_title）から必ず渡され、サブ行（職種 ブランド名 店舗名）を表示する
    offerTitle: string
    offerSubtitleSp?: string
    offerSubtitlePc?: string
}

const OfferRegistrationPage = ({
    webhookUrl,
    offerId,
    offerTitle,
    offerSubtitleSp,
    offerSubtitlePc,
}: Props) => {
    const {
        stepState,
        displayState,
        formState,
        handleNext,
        handlePrev,
        setFormValue,
        updateUserResume,
        setDisplayValue,
        isBlocking
    } = useStepHandler()

    const handleRegistration = useCallback(
        async (data: FormValues) => {
            return submitOfferApplyRegistration(data, offerId)
        },
        [offerId]
    )

    return (
        <div className={styles.offerRegistrationContainer}>
            <ProgressBanner
                currentStep={stepState.currentStep.currentStep}
                headerTitle={offerTitle}
                subtitleSp={offerSubtitleSp}
                subtitlePc={offerSubtitlePc}
            />
            <div className={styles.steps}>
                <StepContainer
                    stepState={stepState}
                    displayState={displayState}
                    formState={formState}
                    stepBoolean={stepState.stepStatus}
                    handleNext={handleNext}
                    handlePrev={handlePrev}
                    setFormValue={setFormValue}
                    updateUserResume={updateUserResume}
                    setDisplayValue={setDisplayValue}
                    webhook={webhookUrl}
                    isBlocking={isBlocking}
                    offerId={offerId}
                    handleRegistration={handleRegistration}
                />
            </div>
        </div>
    )
}

export default OfferRegistrationPage
